import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import getBase64 from '../../../../../helper/images';
import { setAlertDescription } from '../../../../../hooks/actions';

import './index.scss'

interface DropZoneAllScreen {
    handleZone: any
}

const DropzoneFullScreen = (props: DropZoneAllScreen) => {
    const { handleZone } = props

    const [dropzoneDocs, setdropzoneDocs] = useState<boolean>(false)

    const onDrop = useCallback((acceptedFiles, fileRejections) => {
        let namesFilesError = '';

        fileRejections.map((errorFile: any) => {
            namesFilesError = namesFilesError !== '' ? `${namesFilesError}, ${errorFile?.file?.name}` : errorFile?.file?.name
        })

        if (fileRejections.length > 0) {
            setAlertDescription({
                open: true,
                message: `The following files cannot be uploaded, exceeded the size limit (${namesFilesError}), the others files were uploaded`,
                severity: 'warning',
            })
        }

        acceptedFiles.map((file: any) => {
            getBase64(file)
                .then(async (data) => {
                    try {
                        const { name, size } = file;
                        handleZone('file', { base64: data, name, size }, namesFilesError);
                    } catch (e: any) {
                        console.error(e);
                    }
                });
        })
        setdropzoneDocs(false);
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: 'image/jpeg, image/png, application/pdf',
        multiple: true,
        maxFiles: 10,
        maxSize: 26214400,
        noClick: true
    });

    const dropZone = document.getElementById('dropzone-creative-docs');

    window.addEventListener('dragenter', function (e) {
        setdropzoneDocs(true)
    });

    dropZone?.addEventListener('dragleave', function (e) {
        setdropzoneDocs(false)
    });

    return (
        <div id='dropzone-creative-docs' {...getRootProps()} className={dropzoneDocs ? 'dropzone-active-in' : ''}>
            <input {...getInputProps()} />
            {isDragActive && (
                <p className='text-drop-files'>
                    Drop files here
                </p>
            )}
        </div>
    );
};

export default DropzoneFullScreen 